import React, { memo, useEffect, useRef } from 'react';
import targetSvgUrl from '../../look_for_target.svg';
import faceMissingSvgUrl from './face-svg.svg';
import * as CSS from './FacePromptUI.scss';
import { getTranslation, ITranslationKey } from '@/translations';
import { Jute } from '@/index';

interface IParentProps {
	isVisible: boolean;
}

const FacePromptUi: React.FunctionComponent<IParentProps> = ({ isVisible }) => {
	const containerDivRef = useRef<HTMLDivElement>(undefined);
	const timeout = useRef<ReturnType<typeof setTimeout>>(undefined);

	useEffect(() => {
		const canvasDiv = document.getElementById('zapparCanvas');
		const hasBeenAlreadyAdded = !!document.getElementById('facePromptContainer');
		if (!canvasDiv || hasBeenAlreadyAdded) return;

		const containerDiv = document.createElement('div');
		containerDiv.id = 'facePromptContainer';
		containerDiv.classList.add(CSS.Container, CSS.Hidden);
		containerDivRef.current = containerDiv;
		canvasDiv.appendChild(containerDiv);

		const flexDiv = document.createElement('div');
		flexDiv.className = CSS.FlexContainer;
		containerDiv.appendChild(flexDiv);

		const faceSvg = document.createElement('img');
		faceSvg.src = faceMissingSvgUrl;
		faceSvg.className = CSS.FaceSvg;

		const svgContainerDiv = document.createElement('div');
		svgContainerDiv.className = CSS.SVGContainer;
		flexDiv.appendChild(faceSvg);
		flexDiv.appendChild(svgContainerDiv);

		const phoneContainerdiv = document.createElement('div');
		phoneContainerdiv.className = CSS.PhoneContainer;

		const svgImg = document.createElement('img');
		svgImg.src = targetSvgUrl;
		phoneContainerdiv.appendChild(svgImg);

		const span = document.createElement('span');
		span.className = CSS.Text;
		span.innerText = getTranslation(ITranslationKey.pointFaceToCam);

		svgContainerDiv.appendChild(phoneContainerdiv);
		svgContainerDiv.appendChild(span);
    
		return () => {
			const canvasDiv = document.getElementById('zapparCanvas');
			const containerDiv = document.getElementById('facePromptContainer');
			if (!canvasDiv || !containerDiv) return;
			canvasDiv.removeChild(containerDiv);
		};
	}, []);

	useEffect(() => {
		if (timeout.current) clearTimeout(timeout.current);
		const container = containerDivRef?.current;
		if (!container) return;
		if (!isVisible) {
			container.classList.add(CSS.Hidden);
			return;
		};
		if (Jute.isDevRelease) {
			document.getElementsByClassName(CSS.Text)[0].textContent = getTranslation(ITranslationKey.pointFaceToCam);
		};
		timeout.current = setTimeout(() => {
			container.classList.remove(CSS.Hidden)
		}, 200)
	}, [isVisible]);

	useEffect(() => {
		return () => {
			if (timeout.current) clearTimeout(timeout.current);
		}
	}, [])

	return null;
};
export default memo(FacePromptUi);
